import {clsx} from 'clsx';
import {useCallback} from 'react';
import {formatIsoStringToJp} from '../lib/format-iso-string-to-jp';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {shownNumber} from '../press-release-carousel/const';
import styles from './slide.module.css';

export type PressRelease = {
  id: number;
  title: string;
  url: string;
  thumbs: {
    s: string;
  };
  releaseCompleDate: string;
};

type Props = {
  readonly currentIndex: number;
  readonly slideNumber: number;
} & Omit<PressRelease, 'id'>;

export function Slide({
  title,
  url,
  thumbs,
  releaseCompleDate,
  currentIndex,
  slideNumber,
}: Props) {
  // 表示されないスライドは徐々に薄くする
  const gradient = useCallback(() => {
    // 表示されていない右のスライド
    if (
      isContainerQueryAvailable() &&
      slideNumber / shownNumber >= currentIndex
    ) {
      return styles.gradientRightToLeftCQ;
    }

    if (
      !isContainerQueryAvailable() &&
      slideNumber / shownNumber >= currentIndex
    ) {
      return styles.gradientRightToLeftFallback;
    }

    // 表示されていない左のスライド
    if (
      isContainerQueryAvailable() &&
      slideNumber / shownNumber < currentIndex - 1
    ) {
      return styles.gradientLeftToRightCQ;
    }

    if (
      !isContainerQueryAvailable() &&
      slideNumber / shownNumber < currentIndex - 1
    ) {
      return styles.gradientLeftToRightFallback;
    }

    return undefined;
  }, [currentIndex, slideNumber]);

  return (
    <li className={clsx(styles.slide, gradient())}>
      <article className={styles.article}>
        <a href={url} className={styles.imgWrapper}>
          <img src={thumbs.s} width={262} height={148} alt='' />
        </a>

        <div
          className={clsx(
            styles.description,
            isContainerQueryAvailable()
              ? styles.descriptionCQ
              : styles.descriptionFallback,
          )}
        >
          <a href={url}>
            <p className={styles.title}>{title}</p>
          </a>

          <time dateTime={releaseCompleDate} className={styles.date}>
            {formatIsoStringToJp(releaseCompleDate)}
          </time>
        </div>
      </article>
    </li>
  );
}
